<script>
  import { onDestroy } from 'svelte';
  import dayjs from 'dayjs';

  export let dateOfBirth;

  let now = dayjs(),
    years,
    decimals;

  $: {
    const diff = now.diff(dateOfBirth, 'year', true);
    [years, decimals] = diff.toFixed(10).split('.');
  }

  const interval = setInterval(() => {
    now = dayjs();
  }, 100);

  onDestroy(() => clearInterval(interval));
</script>

<dl class="font-medium uppercase">
  <dt
    class="pl-1 text-xl tracking-wider text-gray-400 md:pl-2 md:text-3xl dark:text-gray-600"
  >
    Age
  </dt>

  <dd class="text-gray-900 dark:text-gray-500">
    <span class="text-7xl font-bold md:text-9xl">
      {years}
    </span>
    <span class="text-3xl tabular-nums md:text-6xl">
      ,{decimals}
    </span>
  </dd>
</dl>
